import { DataModel } from '../../dto/data-model.js';
import { Price } from '../price.js';

export enum PromoCodeProtocolType {
  Percentage = 'Percentage',
  Fixed = 'Fixed',
  DownToPrice = 'DownToPrice',
}

export abstract class PromoCodeProtocol extends DataModel {
  abstract get type(): PromoCodeProtocolType;
  abstract calculateDiscount(originalPrice: Price): Price;
}
